import { TableBody, TableCell, TableRow } from "@windmill/react-ui";
import EditDeleteButton from "components/table/EditDeleteButton";
import React from "react";
import useToggleDrawer from "hooks/useToggleDrawer";
import AirportPickupPeriodicHikeTimeDrawer from "components/drawer/AirportPickupPeriodicHikeTimeDrawer";
import MainDrawer from "components/drawer/MainDrawer";
import DeleteModal from "components/modal/DeleteModal";

const AirportPickupPeriodicHikeTimeTable = ({
  airportPickupPeriodicHikeTime,
  perpage,
  currentPage,
  hideDelete,
  hideEdit,
}) => {
  const { title, serviceId, handleModalOpen, handleUpdate } = useToggleDrawer();
  const airportPickupPeriodicHikeTimesorted =
    airportPickupPeriodicHikeTime.sort((a, b) =>
      a.city_names.localeCompare(b.city_names)
    );
  return (
    <>
      <DeleteModal id={serviceId} title={title} />

      <MainDrawer>
        <AirportPickupPeriodicHikeTimeDrawer id={serviceId} />
      </MainDrawer>

      <TableBody>
        {airportPickupPeriodicHikeTimesorted
          ?.slice(0, perpage)
          .map((data, index) => (
            <TableRow key={data.uniquekey}>
              <TableCell className="text-center text-xs">
                {(currentPage - 1) * perpage + index + 1}
              </TableCell>
              <TableCell className="text-center text-xs">
                {data["city_names"]}
              </TableCell>
              <TableCell className="text-center text-xs">
                {data["start_time"]}
              </TableCell>
              <TableCell className="text-center text-xs">
                {data["end_time"]}
              </TableCell>
              <TableCell className="text-center text-xs">
                {data["vehicle_type_names"]}
              </TableCell>
              <TableCell className="text-center text-xs">
                {data["hike"]}
              </TableCell>
              <TableCell className="text-center">
                <EditDeleteButton
                  title={data["Airport Pickup"]}
                  id={data.id}
                  handleUpdate={handleUpdate}
                  handleModalOpen={handleModalOpen}
                  hideDelete={hideDelete}
                  hideEdit={hideEdit}
                />
              </TableCell>
            </TableRow>
          ))}
      </TableBody>
    </>
  );
};

export default AirportPickupPeriodicHikeTimeTable;
